import React, { useState } from "react";
import {
  Box,
  Typography,
  Card,
  Container,
  useTheme,
  Snackbar,
} from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import StrategiesTable from "./StrategiesTable";
import StrategiesDialog from "./StrategiesDialog";
import { Helmet } from "react-helmet";
import {
  updateLoading,
  updateLoadingMsg,
  addActiveRequests,
} from "../../Redux/Reducers/uiSlice";
import { sendWebSocketMessage } from "../../hooks/useWebSocket";
import { selectStrategies } from "../../Redux/Reducers/selectors";

const Strategies = () => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const [dialogOpen, setDialogOpen] = useState(false);
  const [editStrategy, setEditStrategy] = useState(null);
  const [snackbar, setSnackbar] = useState({ open: false, message: "" });

  const strategies = useSelector(selectStrategies);
  const handleAdd = () => {
    setEditStrategy(null);
    setDialogOpen(true);
  };

  const handleEdit = (strategy) => {
    setEditStrategy(strategy);
    setDialogOpen(true);
  };

  const handleDelete = (strategy) => {
    if (
      window.confirm(
        `Are you sure you want to delete strategy "${strategy.name}"?`
      )
    ) {
      sendWebSocketMessage(
        `{"action":"delete_strategy", "data":{"strategyId":${JSON.stringify(
          strategy?.strategyId
        )}}}`
      );
      dispatch(addActiveRequests("delete_strategy"));
      dispatch(updateLoading(true));
      dispatch(updateLoadingMsg("Deleting Strategy..."));

      // setSnackbar({ open: true, message: "Strategy deleted successfully" });
    }
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
    setEditStrategy(null);
  };

  const handleSave = (strategy) => {
    
    if (!strategy || Object.keys(strategy).length === 0) return;

    if (editStrategy) {
      sendWebSocketMessage(
        JSON.stringify({
          action: "modify_strategy",
          data: {
            strategyId: editStrategy.strategyId,
            fields: {
              description: strategy.description,
            },
          },
        })
      );
      dispatch(addActiveRequests("modify_strategy"));
      dispatch(updateLoading(true));
      dispatch(updateLoadingMsg("Updating Strategy..."));
      // setSnackbar({ open: true, message: "Strategy updated successfully" });
    } else {
      sendWebSocketMessage(
        `{"action":"new_strategy", "data":${JSON.stringify(strategy)}}`
      );
      dispatch(addActiveRequests("new_strategy"));
      dispatch(updateLoading(true));
      dispatch(updateLoadingMsg(`Adding Strategy...`));
      // setSnackbar({ open: true, message: "Strategy created successfully" });
    }
    setDialogOpen(false);
    setEditStrategy(null);
  };

  return (
    <>
      <Helmet>
        <title>Strategies | Vantage Alpha</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: theme.palette.mode == "dark" ? theme.palette.grey[50] : '#ebebeb',
          background: theme.palette.mode == "dark" ? theme.palette.grey[50] : '#ebebeb',
          minHeight: "100vh",
          py: 3,
        }}
      >
        <Container maxWidth="xl">
          <Box sx={{ mb: 3 }}>
            <Typography
              variant="h4"
              sx={{
                fontWeight: 600,
                color: theme.palette.text.primary,
                mb: 1,
              }}
            >
              Strategies
            </Typography>
            <Typography
              variant="body1"
              sx={{
                color: theme.palette.text.secondary,
              }}
            >
              Manage your trading strategies and investment approaches
            </Typography>
          </Box>

          <Card
            sx={{
              borderRadius: 2,
              boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
              border: `1px solid ${theme.palette.divider}`,
            }}
          >
            <StrategiesTable
              strategies={strategies}
              onEdit={handleEdit}
              onDelete={handleDelete}
              onAdd={handleAdd}
            />
          </Card>
        </Container>

        <StrategiesDialog
          open={dialogOpen}
          onClose={handleDialogClose}
          strategy={editStrategy}
          onSave={handleSave}
        />
        <Snackbar
          open={snackbar.open}
          autoHideDuration={3000}
          onClose={() => setSnackbar({ open: false, message: "" })}
          message={snackbar.message}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        />
      </Box>
    </>
  );
};

export default Strategies;
